'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _requireLoggedIn = require('./helpers/requireLoggedIn');

var _requireLoggedIn2 = _interopRequireDefault(_requireLoggedIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

exports.default = function (store) {
  return {
    path: 'welcome/refer',

    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(_requireLoggedIn2.default, nextState, replaceState).done.then(cb, cb);
    },

    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('containers/CmsPage/CmsPage').CmsPage
        });
      }, 'try');
    }
  };
};